export const MENSAGEM_FICHA_NAO_PROCESSADA_CIDADAO =
  'Existem fichas ainda não processadas para este cidadão. Atualizar o cadastro de imóvel pode carregar as novas informações.'

export const MENSAGEM_FICHA_NAO_PROCESSADA_IMOVEL =
  'Pode ser atualizado por fichas ainda não processadas. Ao iniciar uma atualização serão carregadas as novas informações.'
